module.exports = __webpack_public_path__ + "static/media/right-arrow-blue.0f7e68dc.svg";